import { Component, OnInit, Inject } from '@angular/core';
import { RegisterMyProfileComponent } from 'projects/web-user-profile/src/app/decorators/my-profile-component.decorator';
import { TemplateConstants } from 'projects/web-user-profile/src/app/models/templates/template-constants';
import { RulesComputedDelegateConfiguration } from 'projects/web-user-profile/src/app/models/templates/modules/configuration/rules-computed-delegate-configuration';
import { BaseProviderInstanceResourceModel, UserModel, ReportProfileBaseModel, AlertInvalidStateFeaturedModel, MicrosoftOfficeReportProfileModel, ReportProfileRulesComputedDelegate, ReportProfileResourceBase, Constants, ZimbraReportProfileModel, ReportProfileDeviceModel, OneDriveReportProfile, SharePointReportProfilePermissions } from '@i2a/web-api-client';
import { ToastrService } from 'ngx-toastr';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { ProfileHelper } from 'projects/web-user-profile/src/app/helpers/profile-helper';
import { IModule } from 'projects/web-user-profile/src/app/models/templates/modules/i-module';
import { ProfileBaseClassComponent } from '../../../../shared/profile-base-class-component';
import { BaseTemplate } from 'projects/web-user-profile/src/app/models/templates/base-template';
import { OneDriveDelegate } from 'projects/web-user-profile/src/app/models/providers/microsoft/one-drive/one-drive-delegate';
import { OneDriveDelegateConfiguration } from 'projects/web-user-profile/src/app/models/templates/modules/configuration/one-drive-delegate-configuration';
import { OneDriveDelegateModuleComponent } from '../one-drive-delegate-module/one-drive-delegate-module.component';
import { SharePointPermissionConfiguration } from 'projects/web-user-profile/src/app/models/templates/modules/configuration/share-point-permission-configuration';
import { SharePointPermissionModuleComponent } from '../../share-point/share-point-permission-module/share-point-permission-module.component';

@RegisterMyProfileComponent(TemplateConstants.MODULE_ONEDRIVE_RULES_COMPUTED_DELEGATE_I2A)
@Component({
  selector: 'i2a-one-drive-rules-computed-delegate-module',
  templateUrl: './one-drive-rules-computed-delegate-module.component.html',
  styleUrls: ['./one-drive-rules-computed-delegate-module.component.scss']
})
export class OneDriveRulesComputedDelegateModuleComponent extends ProfileBaseClassComponent<RulesComputedDelegateConfiguration,OneDriveReportProfile> implements OnInit, IModule<RulesComputedDelegateConfiguration> {
  private resource: BaseProviderInstanceResourceModel;
  public resourceProfile: OneDriveReportProfile;
  public delegates: ReportProfileRulesComputedDelegate[];
  public devices: ReportProfileDeviceModel[];
  constructor(
    toastr: ToastrService,
    @Inject(I18NEXT_SERVICE) i18Next: ITranslationService) {
    super(toastr, i18Next, null);
    this.devices = [];
  }

  ngOnInit() {
  }

  initialize(user: UserModel, profile: ReportProfileBaseModel, configuration: RulesComputedDelegateConfiguration, alerts: AlertInvalidStateFeaturedModel[], resource: BaseProviderInstanceResourceModel, resourceTemplate?: BaseTemplate): void {
    this.baseInitialize(user, profile, configuration, alerts);
    this.resource = resource;
    this.resourceProfile = (<MicrosoftOfficeReportProfileModel>profile).oneDriveProfiles.find(r => r.providerInstanceResource.providerInstanceResourceId == resource.providerInstanceResourceId);

    var allDelegates = this.resourceProfile.rulesComputedDelegates.filter(d=>
      {
       return ( !this.configuration.filterUnreconcileAccounts || !(this.configuration.filterUnreconcileAccounts && d.unreconcileAccount));
      }).sort((a, b) => { return ProfileHelper.compare(a, b, this.i18Next); });
    
    this.delegates = allDelegates;

    // Filter if necessary

    var delegateModuleDelegates = { delegates: new Array<OneDriveDelegate>(), externalDelegates:new Array<OneDriveDelegate>() };
    var delegateModule = resourceTemplate.modules.find(m => m.id == TemplateConstants.MODULE_ONEDRIVE_DELEGATE);
    if (delegateModule != null && delegateModule.isEnabled)
    {
      var delegateModuleConfiguration = delegateModule.configuration as OneDriveDelegateConfiguration;
      delegateModuleDelegates = OneDriveDelegateModuleComponent.SetDelegates(this.resourceProfile.delegates, this.resourceProfile.permissions, delegateModuleConfiguration, this.i18Next);
    }
    
    var permissionModuleDelegates = new Array<SharePointReportProfilePermissions>();
    var permissionModule = resourceTemplate.modules.find(m => m.id == TemplateConstants.MODULE_SHAREPOINT_PERMISSION);    
    if (permissionModule != null && permissionModule.isEnabled)
    {
      var permissionModuleConfiguration = permissionModule.configuration as SharePointPermissionConfiguration;
      permissionModuleDelegates = SharePointPermissionModuleComponent.SetDelegates(this.resourceProfile.permissions, this.resourceProfile.delegates, permissionModuleConfiguration);
    }

    this.delegates = allDelegates.filter(d=>
      {
        if (d.userId != null)
        {
          var delegateModuleIndex = delegateModuleDelegates.delegates.findIndex(dmd => 
            (dmd.permissions != null && dmd.permissions.userId != null && dmd.permissions.userId == d.userId)
            ||
            (dmd.accesses.userId != null && dmd.accesses.userId == d.userId));
          var externalDelegateModuleIndex = delegateModuleDelegates.externalDelegates.findIndex(dmd => 
            (dmd.permissions != null && dmd.permissions.userId != null && dmd.permissions.userId == d.userId)
            ||
            (dmd.accesses.userId != null && dmd.accesses.userId == d.userId));
          var permissionModuleIndex = permissionModuleDelegates.findIndex(dmd => dmd.userId != null && dmd.userId == d.userId);
          if ((delegateModuleIndex >= 0) || (permissionModuleIndex >=0) || (externalDelegateModuleIndex >=0)) { return false; }
        } else if (d.providerInstanceUser != null)
        {
          var delegateModuleIndex = delegateModuleDelegates.delegates.findIndex(dmd => 
            (dmd.permissions != null && dmd.permissions.providerInstanceUser != null && dmd.permissions.providerInstanceUser.providerInstanceResourceId == d.providerInstanceUser.providerInstanceResourceId)
            ||
            (dmd.accesses.providerInstanceUser != null && dmd.accesses.providerInstanceUser.providerInstanceResourceId == d.providerInstanceUser.providerInstanceResourceId));
            var externalDelegateModuleIndex = delegateModuleDelegates.externalDelegates.findIndex(dmd => 
              (dmd.permissions != null && dmd.permissions.providerInstanceUser != null && dmd.permissions.providerInstanceUser.providerInstanceResourceId == d.providerInstanceUser.providerInstanceResourceId)
              ||
              (dmd.accesses.providerInstanceUser != null && dmd.accesses.providerInstanceUser.providerInstanceResourceId == d.providerInstanceUser.providerInstanceResourceId));
            var permissionModuleIndex = permissionModuleDelegates.findIndex(dmd => dmd.providerInstanceUser != null && dmd.providerInstanceUser.providerInstanceResourceId == d.providerInstanceUser.providerInstanceResourceId);
          if ((delegateModuleIndex >= 0) || (permissionModuleIndex >=0) || (externalDelegateModuleIndex >=0)) { return false; }
        } else {
          var delegateModuleIndex = delegateModuleDelegates.delegates.findIndex(dmd => 
            (dmd.permissions != null && dmd.permissions.logonUserId != null && dmd.permissions.logonUserId == d.logonUserId)
            ||
            (dmd.accesses.logonUserId != null && dmd.accesses.logonUserId == d.logonUserId));
          var externalDelegateModuleIndex = delegateModuleDelegates.externalDelegates.findIndex(dmd => 
              (dmd.permissions != null && dmd.permissions.logonUserId != null && dmd.permissions.logonUserId == d.logonUserId)
              ||
              (dmd.accesses.logonUserId != null && dmd.accesses.logonUserId == d.logonUserId));
            var permissionModuleIndex = permissionModuleDelegates.findIndex(dmd => dmd.logonUserId != null && dmd.logonUserId == d.logonUserId);
          if ((delegateModuleIndex >= 0) || (permissionModuleIndex >=0) || (externalDelegateModuleIndex >=0)) { return false; }
        }
        return true;
      }).sort((a, b) => { return ProfileHelper.compare(a, b, this.i18Next); });    
      
    this.devices = this.profile.userProfile.devices.filter(d=>
      {
       return ( !this.configuration.filterIsActiveDevice || this.configuration.filterIsActiveDevice && d.isActive) &&  d.syncDevices.findIndex(s=> s.providerInstanceResourceId == this.resource.providerInstanceResourceId && s.providerTypeId == this.resource.providerTypeId) >= 0;
      });
  }

  alertSent(event): void {
    this.onAlertSent.emit(event);
  }

}
